import React, {
  useCallback,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
} from 'react';
import ModalCommon from 'components/Input/ModalCommon';
import Button from 'components/Button';
import Input from 'components/Input/Input';
import { DatePicker, Divider } from 'antd';
import Select from 'components/Select';
import { ErrorMessage, NewStudentRegisterStyled } from '../styled';
import { toast } from 'sonner';
import { NO_INTERNET } from 'components/messageError';
import CourseServices from 'services/CourseServices';
import CourseScheduleRegistationServices from 'services/CourseScheduleRegistationServices';
import { statusOptions } from '../rules';
import { toolbarOptions3 } from 'assets/sheets/images';
import dayjs from 'dayjs';
import { validateForm } from 'helper/validation';
import { TIME_ZONE } from 'helper/init.constants';
import Editor from 'components/Editor/Editor';

const initiaState = {
  userId: '',
  userCode: '',
  paymentMethod: '',
  status: '',
  paymentDate: '',
  contactDate: '',
  bindingText: '',
  receiptRecipient: '',
  notes: null,
  invoice: null,
  type: 'NEW',
  day: [],
  timezone: TIME_ZONE,
  createdAt: '',
  name: '',
  email: '',
};

const NewStudentRegisterModal = ({ isOpen, onCancel, onSuccess }) => {
  const notesRef = useRef(null);
  const invoiceRef = useRef(null);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(false);
  const [loadingSearch, setLoadingSearch] = useState(false);
  const [courses, setCourses] = useState([]);
  const [coursesId, setCoursesId] = useState(null);
  const [dateCreateAt, setDateCreateAt] = useState(false);
  const [datePayment, setDatePayment] = useState(false);
  const [dateContact, setDateContact] = useState(false);
  const [resetKey, setResetKey] = useState(0);
  const [form, setForm] = useState({
    ...initiaState,
  });
  const [errors, setErrors] = useState([]);

  const handleAfterOpen = useCallback(() => {
    const modalBody = document.querySelector(
      '.new-student-register-modal .ant-modal-body'
    );
    if (modalBody) {
      modalBody.scrollTop = 0;
    }
  }, []);

  useEffect(() => {
    setResetKey((k) => k + 1);
  }, [isOpen]);

  // Add scroll listener to close DatePicker popups
  useEffect(() => {
    const handleScroll = () => {
      // Close all DatePicker popups when scrolling
      if (dateCreateAt) setDateCreateAt(false);
      if (datePayment) setDatePayment(false);
      if (dateContact) setDateContact(false);
    };

    if (isOpen && (dateCreateAt || datePayment || dateContact)) {
      window.addEventListener('scroll', handleScroll, true);
      document.addEventListener('scroll', handleScroll, true);
    }

    return () => {
      window.removeEventListener('scroll', handleScroll, true);
      document.removeEventListener('scroll', handleScroll, true);
    };
  }, [isOpen, dateCreateAt, datePayment, dateContact]);

  const addUserInCourse = async ({ eventId, form }) => {
    setLoading(true);
 
     CourseScheduleRegistationServices.addUserInCourse({
      eventId,
      form: {
        ...form,
        notes: (form.notes),
        invoice: (form.invoice),
      },
    })
      .then((res) => {
        if (res.isOk) {
          setForm({
            ...initiaState,
          });
          setSearch('');
          notesRef.current?.reset();
          invoiceRef.current?.reset();
          onCancel();
          onSuccess();
          toast.success('ユーザーの追加に成功しました');
        }
      })
      .catch((err) => {
        toast.error(err?.message || err || NO_INTERNET);
      })
      .finally(() => setLoading(false))
  };

  const getDataUser = (search) => {
    setForm({
      ...form,
      userId: '',
      name: '',
      email: '',
      userCode: '',
    });
    if (search === '') {
      toast.error('データがありません');
      return;
    }
    setLoadingSearch(true);
    CourseScheduleRegistationServices.getInfoUser({
      search: search,
    })
      .then((res) => {
        if (Array.isArray(res?.data?.items) && res?.data?.items.length !== 0) {
          const data = {
            ...res?.data?.items[0],
            name: `${res?.data?.items[0].name}`,
            userCode: res.data.items[0].memberId,
            userId: res.data?.items[0]._id,
          };
          setForm({
            ...form,
            ...data,
          });
          setErrors(
            errors.filter(
              (error) => !['userId', 'name', 'email'].includes(error.label)
            )
          );
        } else {
          toast.error('データがありません');
        }
      })
      .catch((err) => {
        toast.error(err?.message || NO_INTERNET);
      })
      .finally(() => setLoadingSearch(false));
  };

  const handleSearchStudent = () => {
    getDataUser(search);
  };

  const handleChangeData = ({ label, value }) => {
    setErrors(errors.filter((err) => err.label !== label));
    setForm({
      ...form,
      [label]: value,
    });

    if (label === 'courseId') {
      getCourseSchedule(value);
    }
  };

  const getCourseSchedule = useCallback(
    (id) => {
      CourseScheduleRegistationServices.getCourseSchedules(id)
        .then((res) => {
          setCoursesId(
            res?.data?.items.map((item) => ({
              label: item.eventId,
              value: item._id,
            }))
          );
        })
        .catch((err) => toast.error(err.message || NO_INTERNET))
        .finally(() => setLoading(false));
    },
    [form.courseId]
  );

  const validations = [
    {
      label: 'userId',
      value: form.userId,
      rules: [
        {
          required: true,
          message: '会員IDを入力してください。',
        },
      ],
    },
    {
      label: 'name',
      value: form.name,
      rules: [
        {
          required: true,
          message: '名前を入力してください。',
        },
      ],
    },
    {
      label: 'email',
      value: form.email,
      rules: [
        {
          required: true,
          message: 'メールアドレスを入力してください。',
        },
      ],
    },
    {
      label: 'courseId',
      value: form.courseId,
      rules: [
        {
          required: true,
          message: 'コースを選択してください。',
        },
      ],
    },
    {
      label: 'eventId',
      value: form.eventId,
      rules: [
        {
          required: true,
          message: '開催IDを選択してください。',
        },
      ],
    },
    {
      label: 'paymentMethod',
      value: form.paymentMethod,
      rules: [
        {
          required: true,
          message: '支払い方法を選択してください。',
        },
      ],
    },
    {
      label: 'status',
      value: form.status,
      rules: [
        {
          required: true,
          message: 'ステータスを選択してください。',
        },
      ],
    },
    {
      label: 'createdAt',
      value: form.createdAt,
      rules: [
        {
          required: true,
          message: '申込日を選択してください。',
        },
      ],
    },
  ];

  const removeEmpty = (obj) => {
    return Object.fromEntries(
      Object.entries(obj).filter(
        ([, value]) => value !== '' && value !== null && value !== undefined
      )
    );
  };

  const handleAddUser = () => {
    const isValid = validateForm(form, validations, (errs) => {
      setErrors(errs);
    });

    if (!Array.isArray(isValid) || isValid.length > 0) {
      return;
    }

    const { eventId, ...rest } = form;

    addUserInCourse({
      eventId,
      form: removeEmpty({
        ...rest,
      }),
    });
  };

  const getCourses = () => {
    setLoading(true);
    CourseServices.getCourses()
      .then((res) => {
        setCourses(
          res.data
            .map((item) => ({
              value: item._id,
              label: item.name,
            }))
            .map((i) =>
              i.label === 'インテグレーティッドトレーニング'
                ? {
                  value: i.value,
                  label: 'インテグレーティッド',
                }
                : i
            )
        );
      })
      .catch((err) => {
        toast.error(err?.message || NO_INTERNET);
      })
      .finally(() => setLoading(false));
  };

  const getCourseRegistrationById = useCallback(() => {
    setLoading(true);
    CourseScheduleRegistationServices.getCourseRegistrationById()
      .then((res) => {
        setCoursesId(
          res?.data?.items.map((item) => ({
            value: item._id,
            label: item.eventId,
          }))
        );
      })
      .catch(() => { })
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    if (isOpen) {
      getCourses();
      getCourseRegistrationById();

      // Reinit editor snapshots after modal opens
      setTimeout(() => {
        notesRef.current?.reinitSnapshot();
        invoiceRef.current?.reinitSnapshot();
      }, 100);
    }
  }, [isOpen]);



  useLayoutEffect(() => {
    if (!isOpen || loading) return;

    requestAnimationFrame(() => {
      const modalBody = document.querySelector('.ant-modal-body');
      if (modalBody) modalBody.scrollTop = 0;
    });
  }, [isOpen, loading]);

  const handleChangeDate = ({ label, value }) => {
    setErrors(errors.filter((err) => err.label !== label));
    setForm({
      ...form,
      [label]: dayjs.isDayjs(value) ? dayjs(value).format('YYYY/MM/DD') : '',
    });
  };

  return (
    <NewStudentRegisterStyled>
      <ModalCommon
        onAfterOpen={handleAfterOpen}
        title="個別追加"
        padding={[24, 24, 24, 24]}
        open={isOpen}
        onCancel={() => {
          onCancel();
          setErrors([]);
          setSearch('');
          setForm({
            ...initiaState,
          });
          notesRef.current?.reset();
          invoiceRef.current?.reset();
        }}
        width={600}
        heightHeader={56}
        rootClassName="new-student-register-modal"
        forceRender
        footer={
          <div className="flex h-max justify-end gap-4 border-t border-[#e9e9e9] pt-4">
            <Button
              width={120}
              height={40}
              btnType="back"
              onClick={() => {
                onCancel();
                setSearch('');
                setForm({
                  ...initiaState,
                });
                setErrors([]);
                notesRef.current?.reset();
                invoiceRef.current?.reset();
              }}
              fontSize={14}
            >
              キャンセル
            </Button>
            <Button
              type="primary"
              onClick={handleAddUser}
              fontSize={14}
              loading={loading}
              width={120}
              height={40}
            >
              <p style={{ letterSpacing: '0' }}>追加</p>
            </Button>
          </div>
        }
      >
        <div className="flex w-full items-center justify-between">
          <Input
            placeholder={'名前、メールアドレス、会員ID'}
            width={390}
            height={40}
            value={search}
            onChange={(e) => setSearch(e)}
          />
          <Button
            width={84}
            height={40}
            btnType="outline"
            onClick={handleSearchStudent}
            loading={loadingSearch}
          >
            <p style={{ letterSpacing: '0' }}>検索</p>
          </Button>
        </div>
        <Divider className="m-0" />
        <Input
          title="userId"
          label="会員ID"
          format="memberId"
          required
          disabled
          isPopup={true}
          $autoTrim={true}
          errors={errors}
          widthInput={390}
          heightInput={38}
          widthLabel={136}
          value={form.userCode}
          $paddingMessage={152}
        />
        <Input
          title="name"
          label="名前"
          required
          disabled
          $autoTrim={true}
          widthInput={390}
          heightInput={38}
          errors={errors}
          widthLabel={136}
          value={form.name}
          $paddingMessage={152}
        />
        <Input
          title="email"
          label="メールアドレス"
          required
          disabled
          $autoTrim={true}
          errors={errors}
          widthInput={390}
          heightInput={38}
          widthLabel={136}
          value={form.email}
          $paddingMessage={152}
        />
        <Select
          title="courseId"
          label="コース"
          required
          $autoTrim={false}
          rules={[{ required: true, message: '名前を入力してください' }]}
          widthSelect={390}
          $heightSelect={40}
          widthLabel={136}
          errors={errors}
          options={courses}
          value={form.courseId}
          onChange={(e) =>
            handleChangeData({ label: 'courseId', value: e.value })
          }
          $paddingMessage={152}
        />
        <Select
          title="eventId"
          label="開催ID"
          required
          $autoTrim={false}
          rules={[{ required: true, message: '名前を入力してください' }]}
          widthSelect={390}
          $heightSelect={40}
          widthLabel={136}
          errors={errors}
          options={coursesId}
          value={form.eventId}
          onChange={(e) =>
            handleChangeData({ label: 'eventId', value: e.value })
          }
          $paddingMessage={152}
        />
        <Select
          title="paymentMethod"
          label="支払い方法"
          required
          $autoTrim={false}
          rules={[{ required: true, message: '名前を入力してください' }]}
          widthSelect={390}
          $heightSelect={40}
          widthLabel={136}
          errors={errors}
          options={[
            {
              label: 'カード払い',
              value: 'CREDIT_CARD',
            },
            {
              label: '銀行振込',
              value: 'BANK_TRANSFER',
            },
            {
              label: 'PayPal',
              value: 'PAYPAL',
            },
            {
              label: '未定',
              value: 'UNDECIDED',
            },
          ]}
          value={form.paymentMethod}
          onChange={(e) =>
            handleChangeData({ label: 'paymentMethod', value: e.value })
          }
          $paddingMessage={152}
        />
        <Select
          title="status"
          label="ステータス"
          required
          $autoTrim={false}
          rules={[{ required: true, message: '名前を入力してください' }]}
          widthSelect={390}
          $heightSelect={40}
          widthLabel={136}
          errors={errors}
          options={statusOptions.map((item) =>
            item.label === '最小催行達成待ち'
              ? {
                label: '最少催行達成待ち',
                value: item.value,
              }
              : item
          )}
          value={form.status}
          onChange={(e) =>
            handleChangeData({ label: 'status', value: e.value })
          }
          $paddingMessage={152}
        />
        <div className="flex shrink-0 items-center gap-[16px]">
          <span className="w-[136px]">
            申込日<span className="ml-1 text-red-500">*</span>
          </span>
          <div className="flex w-[390px] flex-col items-start justify-start">
            <DatePicker
              format="YYYY/MM/DD"
              placeholder="yyyy/mm/dd"
              className={`h-10 w-full xl:h-8 xl:rounded-[4px] 2xl:h-9 ${errors.filter((e) => e.label === 'createdAt').length > 0 ? 'border-[#ff4d4f] shadow-error' : ''}`}
              getPopupContainer={(trigger) => trigger.parentNode}
              open={dateCreateAt}
              onOpenChange={(open) => {
                requestAnimationFrame(() => {
                  window.dispatchEvent(new Event('resize'));
                });
                setDateCreateAt(open);
              }}
              value={form.createdAt ? dayjs(form.createdAt) : null}
              onChange={(date) =>
                handleChangeDate({ label: 'createdAt', value: date })
              }
            />
            <ErrorMessage
              $paddingMessage={152}
              message={
                errors?.find((err) => err.label === 'createdAt')?.message ||
                null
              }
            >
              {errors?.find((err) => err.label === 'createdAt')?.message}
            </ErrorMessage>
          </div>
        </div>
        <div className="flex items-center gap-4 2xl:gap-[16px]">
          <span className="w-[136px]">支払日</span>
          <div className="flex w-[390px] flex-col items-start justify-start">
            <DatePicker
              className="h-10 w-full xl:h-8 xl:rounded-[4px] 2xl:h-9"
              format="YYYY/MM/DD"
              placeholder="yyyy/mm/dd"
              getPopupContainer={(trigger) => trigger.parentNode}
              open={datePayment}
              onOpenChange={(open) => {
                setDatePayment(open);
              }}
              value={form.paymentDate ? dayjs(form.paymentDate) : null}
              onChange={(date) =>
                handleChangeDate({ label: 'paymentDate', value: date })
              }
            />
          </div>
        </div>
        <div className="flex items-center gap-4">
          <span className="w-[136px]">入金後連絡</span>
          <div className="flex w-[390px] flex-col items-start justify-start">
            <DatePicker
              className="h-10 w-full xl:h-8 xl:rounded-[4px] 2xl:h-9"
              format="YYYY/MM/DD"
              placeholder="yyyy/mm/dd"
              getPopupContainer={(trigger) => trigger.parentNode}
              open={dateContact}
              onOpenChange={(open) => {
                setDateContact(open);
              }}
              value={form.contactDate ? dayjs(form.contactDate) : null}
              onChange={(date) =>
                handleChangeDate({ label: 'contactDate', value: date })
              }
            />
          </div>
        </div>
        <Select
          title="bindingText"
          label="製本テキスト"
          $autoTrim={false}
          widthSelect={390}
          $heightSelect={40}
          widthLabel={136}
          errors={errors}
          options={[
            {
              label: '購入する',
              value: 'PURCHASE',
            },
            {
              label: '送付済み',
              value: 'SENT',
            },
          ]}
          value={form.bindingText}
          onChange={(e) =>
            handleChangeData({ label: 'bindingText', value: e.value })
          }
          $paddingMessage={152}
        />
        <Select
          title="receiptRecipient"
          label="領収書"
          $autoTrim={false}
          widthSelect={390}
          $heightSelect={40}
          widthLabel={136}
          errors={errors}
          options={[
            {
              label: '発行希望',
              value: 'REQUEST',
            },
            {
              label: '発行済み',
              value: 'ALREADY_ISSUED',
            },
          ]}
          value={form.receiptRecipient}
          onChange={(e) =>
            handleChangeData({ label: 'receiptRecipient', value: e.value })
          }
          $paddingMessage={152}
        />
        <Editor
          ref={notesRef}
          label={'備考'}
          title="notes"
          alignLabel="center"
          widthLabel={136}
          options={[toolbarOptions3]}
          widthEditor={390}
          heightEditor={200}
          value={form.notes ?? ''}
          resetKey={resetKey}
          onChange={handleChangeData}
        />
        <Editor
          ref={invoiceRef}
          label={'請求書'}
          title="invoice"
          alignLabel="center"
          widthLabel={136}
          resetKey={resetKey}
          options={[toolbarOptions3]}
          widthEditor={390}
          heightEditor={200}
          value={form.invoice ?? ''}
          onChange={handleChangeData}
        />
      </ModalCommon>
    </NewStudentRegisterStyled>
  );
};

export default NewStudentRegisterModal;
